import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AuthLayout from '../../templates/AuthLayout';
import PasswordResetForm from '../../molecules/form/PasswordReset';
import { Helmet } from 'react-helmet';
import Notice from '../../molecules/Notice';
import { useTranslation } from 'react-i18next';
const PasswordReset = ({ notice, }) => {
    const { t } = useTranslation();
    const expires = new URLSearchParams(window.location.search).get('expires');
    const [noticeState, setNoticeState] = useState(notice);
    useEffect(() => {
        setNoticeState(notice);
    }, [notice]);
    useEffect(() => {
        if (expires) {
            parseInt(expires);
        }
        // @ts-ignore expires is cast to int above
        if (expires < Math.floor(Date.now() / 1000)) {
            setNoticeState({
                type: 'error',
                text: t('password_reset.timestamp_not_valid'),
                title: t('password_reset.timestamp_not_valid'),
            });
        }
    }, [expires, t]);
    return (_jsxs(AuthLayout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('password_reset.reset_title') }) }), _jsx("p", { children: t('password_reset.reset_password_subtext') }), _jsx("br", {}), " ", _jsx("br", {}), noticeState && _jsx(Notice, { ...noticeState }), _jsx(PasswordResetForm, {})] }));
};
export default PasswordReset;
